module.exports = __webpack_public_path__ + "static/media/kid15.6aa77fa7.png";